var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-select",
    {
      staticClass: "w-100 tag-picker",
      attrs: {
        placeholder: _vm.$t("chatbotv2.chooseATag"),
        notFoundContent: _vm.$t("chatbotv2.noTagFound"),
        size: "large",
        "show-search": "",
        "filter-option": false,
      },
      on: {
        change: _vm.handleChange,
        search: _vm.handleSearch,
        select: _vm.handleSelect,
      },
      model: {
        value: _vm.selectedTagId,
        callback: function ($$v) {
          _vm.selectedTagId = $$v
        },
        expression: "selectedTagId",
      },
    },
    _vm._l(_vm.getFilteredResult(), function (tag, index) {
      return _c("a-select-option", { key: index, attrs: { value: tag._id } }, [
        _c("div", { staticClass: "item-container" }, [
          _c("div", { staticClass: "title" }, [
            _c("div", { staticClass: "logo-container" }, [
              _c("div", {
                staticClass: "circle",
                style: { "background-color": tag.color },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [_vm._v(_vm._s(tag.name))]),
          ]),
        ]),
      ])
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }